"use client";
import { j as e } from "./jsx-runtime-CJ-St4mQ.mjs";
import { forwardRef as c, useContext as l } from "react";
import { a as n } from "./Table.style-CZNieSq3.mjs";
import { T as s } from "./TableContext-DbkGJo7V.mjs";
const u = c(
  (t, r) => {
    const { className: a, ...o } = t, { isStickyHeader: i, size: m } = l(s);
    return /* @__PURE__ */ e.jsx(s.Provider, { value: { isHeader: !0, size: m }, children: /* @__PURE__ */ e.jsx(
      "thead",
      {
        ref: r,
        className: n({ className: a, isSticky: i }),
        ...o
      }
    ) });
  }
);
export {
  u as TableHead
};
